import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import BigStoryCardCurve from "../big-story-card-curve/index";
import SmallStoryCardCurve from "../small-story-card-curve/index";

import styles from "./styles.m.css";

const TewlveStoryThreeCollectionStoryStack = ({
  bigStory,
  mobileStoryCount,
  stories,
  className,
  verticalimg = false,
  bigimage = false,
  bigStoryHover = false
}) => {
  if (stories.length < 1) {
    return null;
  }
  const [pageName, setPageName] = useState("home");
  useEffect(() => {
    const getpageName = global && global.location.pathname;
    const pageName = getpageName.split("/").pop();
    const getPFrom = pageName || "home";
    setPageName(getPFrom);
  }, []);

  const stack = [
    <BigStoryCardCurve
      story={stories[0]}
      key={stories[0].id}
      className={styles["first-big-card"]}
      bigimage={bigimage}
      pFrom={`${pageName}-twelve-story-collection`}
    />
  ].concat(
    stories.slice(1).map((story, index) => (
      <SmallStoryCardCurve
        story={story}
        verticalimg={verticalimg}
        className={`
          ${styles[index + 1 >= mobileStoryCount ? "mobile-hide" : ""]}
          ${styles["line-separater"]}
          ${styles[index + 2 === mobileStoryCount ? "skip-line" : ""]}
        `}
        key={story.id}
        pFrom={`${pageName}-twelve-story-collection`}
      />
    ))
  );
  return <div className={`${styles["base"]} ${className}`}>{stack}</div>;
};

TewlveStoryThreeCollectionStoryStack.propTypes = {
  bigStory: PropTypes.bool,
  mobileStoryCount: PropTypes.number,
  bigimage: PropTypes.bool,
  verticalimg: PropTypes.bool,
  stories: PropTypes.arrayOf(BigStoryCardCurve.propTypes.story),
  className: PropTypes.string,
  bigStoryHover: PropTypes.bool
};

export default TewlveStoryThreeCollectionStoryStack;
